<template>
  <b-row class="h-100">
    <b-col class="container">
      <div
        class="d-flex flex-row justify-content-between align-items-center pl-4 pr-4 pt-3"
      >
        <h5>
          Doctor Orders<br />
          <span class="grid-count color-custom-dark-grey"
            >({{ list.length }} documents)</span
          >
        </h5>
        <div>
          <b-button
            v-if="formHasComponents"
            variant="primary"
            class="pl-3 pr-3 pt-1 pb-1 mr-2"
            size="sm"
            @click="addSubmit"
          >
            <i class="fa fa-plus mr-2"></i> New
          </b-button>
          <b-button
            variant="primary"
            class="pl-3 pr-3 pt-1 pb-1 mr-2"
            size="sm"
            @click="addSubmitFile"
          >
            <i class="fa fa-cloud-upload-alt mr-2"></i> Upload
          </b-button>
        </div>
      </div>
      <div class="mt-3 mb-0 px-4 w-100 d-flex flex-row justify-content-between">
        <div class="d-flex align-items-center">
          <vue-toggles
            @click="toggleTransferMedsToMars()"
            :value="transferToMars"
            height="20"
            width="30"
            checkedBg="#34C759"
            uncheckedBg="#FF6161"
          />
          <small class="ml-2">Transfer Medications to MARS</small>
        </div>
        <div class="d-flex flex-row justify-content-end align-items-center">
          <top-paginator
            :total="itemsFilter.length"
            :page="paginator.page"
            :perPage="paginator.perPage"
            @change-page="changePage"
          />
        </div>
      </div>
      <div class="px-4">
        <grid
          v-if="client && eoc && form"
          :groupFeature="false"
          :store="gridConfig.store"
          :columns="columns"
          :autoHeight="true"
          :data="items"
          :selectionMode="gridConfig.selectionMode"
          :columnLines="gridConfig.columnLines"
          :searchFeature="true"
          :stripeFeature="false"
          :scrollable="allowScroll"
          @renderrows="hookDropdownButtons"
          @renderrow="hookDropdownButtons"
        />
      </div>

      <document-file-add-edit-modal
        v-if="showAddFileEditor"
        v-model="showAddFileEditor"
        :formId="formId"
        :eocId="eocId"
        @onModify="onModifyAddFile"
        :clientId="clientId"
        :submitId.sync="submitId"
      />
      <document-add-edit-modal
        v-if="showAddDocumentEditor"
        v-model="showAddDocumentEditor"
        :formId="submitFormId"
        @onModify="onModifyAddDocument"
        :clientId="clientId"
        :eocId="eocId"
        :submitId="submitId"
        :parentDocumentId="parentDocumentId"
        :otherResults="otherResults"
        :defaultValues="defaultValues"
      />
      <document-view-modal
        v-if="showDocumentViewer"
        v-model="showDocumentViewer"
        :documentId="submitId"
        @onModify="onModifyAddDocument"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import eocServer from "../../server/eoc";
import patientServer from "../../server/patient";
import catalogServer from "../../server/catalog";
import formSubmitterServer from "../../server/formSubmitter";
import { getFormBuilderComponents } from "../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import { formatDate } from "../../helpers/date";
import DocumentFileAddEditModal from "./document/DocumentFileAddEditModal.vue";
import DocumentAddEditModal from "./document/DocumentAddEditModal.vue";
import DocumentViewModal from "./document/DocumentViewModal.vue";
import TopPaginator from "../controls/TopPaginator.vue";

export default {
  name: "EocViewDoctorOrderDocuments",
  components: {
    Grid,
    TopPaginator,
    DocumentFileAddEditModal,
    DocumentAddEditModal,
    DocumentViewModal
  },
  props: ["clientId", "eocId", "showing", "transferToMarsValue"],
  data() {
    return {
      list: [],
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false,
        store: {}
      },
      paginator: {
        page: 0,
        perPage: 10
      },
      search: "",
      form: null,
      showAddFileEditor: false,
      showAddDocumentEditor: false,
      showSendLinkEditor: false,
      showDocumentViewer: false,
      selectedForms: [],
      submitFormId: null,
      submitId: null,
      parentDocumentId: null,
      otherResults: [],
      defaultValues: null,
      client: null,
      eoc: null,
      allLocationDoctorOrderFormId: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("formSubmitter", ["deleteFormSubmitterSubmit"]),
    async fetchData() {
      await this.getEoc();
      await this.getClient();
      await this.fetchFormSubmitterSubmits();
      if (!this.selectedLocation) {
        this.allLocationDoctorOrderFormId = await catalogServer.getDoctorOrderForLocation(
          this.eoc.locationId
        );
      }
      if (this.formId || this.allLocationDoctorOrderFormId) {
        this.form = await this.getFormBuilderFormById(
          this.formId || this.allLocationDoctorOrderFormId
        );
      }
    },
    async getEoc() {
      this.eoc = await eocServer.get(this.eocId);
    },
    async getClient() {
      this.client = await patientServer.get(this.clientId);
    },
    async fetchFormSubmitterSubmits() {
      const submits = await formSubmitterServer.queryByCateg(
        "doctorOrder",
        this.clientId,
        this.eocId
      );
      this.list = submits;
    },
    addSubmit() {
      this.submitId = null;
      this.submitFormId = this.formId;
      this.parentDocumentId = null;
      this.otherResults = [];
      this.defaultValues = null;
      this.showAddDocumentEditor = true;
    },
    addSubmitFile() {
      this.submitId = null;
      this.showAddFileEditor = true;
    },
    changePage(page) {
      this.paginator.page = page;
    },
    onModifySendLink() {
      this.showSendLinkEditor = false;
    },
    onModifyAddFile() {
      this.showAddFileEditor = false;
      this.fetchFormSubmitterSubmits();
    },
    onModifyAddDocument() {
      this.showAddDocumentEditor = false;
      this.fetchFormSubmitterSubmits();
    },
    exportExcel() {
      this.$refs.grid.exportExcel();
    },
    toggleTransferMedsToMars() {
      this.transferToMars = !this.transferToMars;
    }
  },
  computed: {
    ...mapState("formBuilder", {
      forms: state => state.list
    }),
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    ...mapGetters("formSubmitter", ["superComputeFormSubmitterValue"]),
    ...mapGetters("client", ["selectedLocation"]),
    formId() {
      return (
        this.selectedLocation?.doctorOrderFormId ||
        this.allLocationDoctorOrderFormId
      );
    },
    itemsFilter() {
      let newList = this.list;
      return newList;
    },
    items() {
      return this.itemsFilter.slice(
        this.paginator.page * this.paginator.perPage,
        (this.paginator.page + 1) * this.paginator.perPage
      );
    },
    allowScroll() {
      return this.items.length == 1 ? false : true;
    },
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    hasSubmits() {
      return this.items.filter(item => item.mode == "Results").length > 0;
    },
    columns() {
      let columns = [];

      columns.push({
        text: "REF#",
        field: "documentRefNumber",
        type: "template",
        width: 90,
        editor: false,
        template: data => data.record.data.documentRefNumber,
        sortable: false
      });
      columns.push({
        text: "Created at",
        field: "createdAt",
        type: "template",
        width: 180,
        editor: false,
        template: data => `${formatDate(data.record.data.createdAt)}`,
        sortable: false
      });
      columns.push({
        text: "Created by",
        field: "user",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          `${
            data.record.data.createdBy
              ? this.formatUser(data.record.data.createdBy)
              : "-"
          }`,
        sortable: false
      });
      columns.push({
        text: "Status",
        field: "status",
        type: "template",
        flex: 1,
        editor: false,
        template: data => {
          const status = data.record.data.status;
          let className = "warning";
          if (status == "Completed") {
            className = "success";
          }
          if (status == "Draft") {
            className = "danger";
          }
          return `<span class="badge-v2 py-2 badge-${className} badge-fixed-size">${status}</span>`;
        },
        sortable: false
      });
      columns.push({
        text: "Effective date",
        field: "effectiveDate",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          data.record.data.effectiveDate
            ? formatDate(data.record.data.effectiveDate)
            : "",
        sortable: false
      });

      columns.push({
        text: "Type",
        field: "mode",
        type: "template",
        flex: 1,
        editor: false,
        template: ({ record }) =>
          record.data.mode === "File" ? "File" : "Document",
        sortable: false
      });

      columns.push({
        text: "Tools",
        type: "action",
        field: "action",
        cellCls: "pointer-cell",
        align: "right",
        flex: 1,
        actions: [
          {
            tooltip: "View",
            renderer: () =>
              `<i class="fa fa-search-plus color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"></i>`,
            onClick: ({ record }) => {
              if (record.data.mode == "File") {
                const url = formSubmitterServer.viewUrl(record.data.id);
                window.open(url, "_blank");
              } else {
                this.submitId = record.data.id;
                this.showDocumentViewer = true;
              }
            }
          },
          {
            tooltip: "More",
            renderer: ({ record }) => {
              const actions = [];

              if (
                (record.status == "Completed" &&
                  this.hasCurrentUserDocumentPermission(
                    record.data.formId,
                    "hasCompleteAccess"
                  )) ||
                (record.status != "Completed" &&
                  this.hasCurrentUserDocumentPermission(
                    record.data.formId,
                    "hasEntryAccess"
                  ))
              ) {
                actions.push({
                  content: "Edit",
                  callback: () => {
                    this.submitId = record.id;
                    this.submitFormId = record.data.formId;
                    this.parentDocumentId = record.data.parentDocumentId;
                    if (record.mode == "File") this.showAddFileEditor = true;
                    else {
                      this.showAddDocumentEditor = true;
                      if (record.data.parentDocumentId) {
                        this.otherResults = [
                          ...this.list.filter(
                            mTPR =>
                              mTPR.parentDocumentId ==
                                record.data.parentDocumentId &&
                              mTPR.id != record.id
                          )
                        ];
                      } else this.otherResults = [];
                    }
                  }
                });
              }

              if (
                record.status != "Completed" &&
                this.hasCurrentUserDocumentPermission(
                  record.data.formId,
                  "hasEntryAccess"
                )
              ) {
                actions.push({
                  content: "Delete",
                  callback: () => {
                    this.$dialog
                      .confirm(
                        {
                          title: "Are you sure you want to delete this record?"
                        },
                        {
                          view: "confirm-delete"
                        }
                      )
                      .then(async () => {
                        const result = await this.deleteFormSubmitterSubmit({
                          submitId: record.id,
                          formId: record.data.formId,
                          clientId: this.clientId,
                          eocId: this.eocId
                        });
                        if (result.errorCode) {
                          this.$dialog.alert("Error: " + result.message);
                        } else {
                          this.showAlertSuccess();
                          this.fetchFormSubmitterSubmits();
                        }
                      })
                      .catch(function() {});
                  }
                });
              }

              return this.createDropdownButton({
                items: actions
              });
            }
          }
        ]
      });
      return columns;
    },
    formHasComponents() {
      return (
        this.form &&
        getFormBuilderComponents(this.form.current.content).length > 0
      );
    },
    transferToMars: {
      get() {
        return this.transferToMarsValue;
      },
      set(newValue) {
        this.transferToMarsValue = newValue;
        this.$emit("change-transfer-to-mars", newValue);
      }
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        await this.fetchData();
      }
    }
  }
};
</script>

<style scoped>
.grid-count {
  font-size: 0.8rem;
}
</style>
